

























import { getFrameName } from '../../data/QuicNames'
export default {
    name: 'infoitem',
    props: ['keyname', 'keyinfolist', 'collapse'],
    data(){
        return {
            showChildren: this.collapse
        }
    },
    methods: {
        toggleChildren: function(){
            this.showChildren = !this.showChildren
        },
        frameName(frametype) {
            return getFrameName(frametype)
        }
    }
}
